import { UserOutlined } from '@ant-design/icons';
import { Avatar, Flex, Grid, Typography } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { WebCrm_Webhook_API } from '../../../../../api/attachments.api';
import { matchStatusByName, taskColorByUUID, TaskStatus } from '../../../../../shared/constants/task-status';
import { TaskReview } from './task-review';
import { Application_TrackPlannedStatus } from './track-planned-status';
import { useResizeObserverDebounced } from '../../../../../shared/hooks/useElementSize';
import styles from '../index.module.css'

export const Application_TrackStatus = (props) => {
    const { cardRef, uuid } = props;
    const task = useSelector(state => state.applications.currentApplicationData);
    const isPlanned = task?.status === 'Запланировано';
    const screens = Grid.useBreakpoint();

    const { width = 0, height = 0 } = useResizeObserverDebounced(cardRef);
    const matchedStatus = matchStatusByName(task?.status)

    //#region responsible photo
    const [image, setImage] = useState(undefined);
    const fetchPhoto = useCallback(async () => {
        if (!task?.responsible_uuid) return;
        try {
            const photo64 = await WebCrm_Webhook_API.Request.getPhotoByImplementerUUID(task?.responsible_uuid);
            if (photo64?.length > 128) {
                setImage(`data:image/jpeg;base64,${photo64}`)
            }
        } catch (error) { }
    }, [task?.responsible_uuid]);
    useEffect(() => {
        fetchPhoto();
    }, [fetchPhoto, task?.responsible_uuid]);
    //#endregion

    if (isPlanned) {
        return (
            <Application_TrackPlannedStatus cardRef={cardRef} />
        )
    }
    const sizes = {
        lg: screens.lg && width >= 900,
        md: (width >= 850),
        sm: (width >= 800),
    }
    const isDoneOrCanceled = [TaskStatus.DONE.uuid, TaskStatus.CANCELED.uuid].includes(matchedStatus.uuid);

    return (
        <Flex style={{ width: '100%', height: 'auto', minHeight: 190, borderRadius: 8, backgroundColor: '#FFFFFF', borderLeft: `26px solid ${taskColorByUUID(matchedStatus.uuid)}`, padding: 16 }} gap={16}>
            <Flex style={{ width: '100%', borderRadius: 8, backgroundColor: '#FFFFFF' }} gap={16} wrap align='center' vertical={!sizes.sm}>
                <Flex vertical align='center' justify='center'>
                    <Typography.Title
                        className={styles.app_status_title}
                        level={2}
                        style={{ margin: 0, color: matchedStatus.background, width: sizes.sm ? 160 : '100%', fontWeight: 900 }}
                    >
                        {matchedStatus.summary}
                    </Typography.Title>
                </Flex>
                <Flex align='center' justify='center' gap='small' wrap>
                    <Flex vertical style={{ padding: 4 }} >
                        <Avatar
                            size={{ xs: 80, sm: 80, md: 80, lg: 80, xl: 80, xxl: 100 }}
                            icon={image ? <img src={image} alt={task?.responsible || 'Неизвестный сотрудник'} style={{ width: '100%', height: '100%', borderRadius: '50%' }} /> : <UserOutlined />}
                        />
                    </Flex>
                    <Flex vertical style={{ padding: 4, maxWidth: isDoneOrCanceled ? 300 : '' }} gap={4}>
                        {!isDoneOrCanceled && (
                            <Typography.Title className={styles.app_implementer_status_title} level={2}>
                                Скоро с вами свяжется
                            </Typography.Title>
                        )}
                        <Typography.Title  className={styles.app_implementer_name}  level={4}>
                            {task?.responsible || 'Неизвестный сотрудник'}
                        </Typography.Title>
                        <Flex className={styles.app_implementer_info} gap={8} align='center' style={{ width: '100%' }}>
                            <Typography.Text style={{ color: '#4D525B', width: 'fit-content' }}>
                                IT {task?.phonenumber}
                            </Typography.Text>
                            <Typography.Link style={{ color: '#4D525B', width: 'fit-content' }} href='tel:+77273901112'>
                                +7 727 390 1112
                            </Typography.Link>
                        </Flex>
                    </Flex>
                </Flex>
                {isDoneOrCanceled && (
                    <Flex vertical style={{ padding: 4, marginLeft: sizes.md ? 'auto' : 0 }} gap={8}>
                        <TaskReview uuid={uuid} />
                    </Flex>
                )}
            </Flex>
        </Flex>

    )
}